import React from 'react';
import PropTypes from 'prop-types';

import { SpacerContainer } from './styles';

class Spacer extends React.Component {
    render() {
        return <SpacerContainer Size={this.props.Size} />
    }
}

Spacer.propTypes = {
    Size: PropTypes.string.isRequired,
};

export default Spacer;